module.exports = __webpack_public_path__ + "img/logo_MobileStore.321ec343.svg";